import type { NexusSignal } from "@otto-ec/global-resources/nexus";

declare module "@otto-ec/nexus-registry/reco/cinemas" {
    interface RecoCinemasRaw {
        renderBounceLayerRecommendationsInternal: NexusSignal<any>,
        renderWishlistRecommendationsInternal: NexusSignal<any>,
        renderOrderOverviewRecommendationsInternal: NexusSignal<any>,
        renderPdpRecommendationsInternal: NexusSignal<any>,
    }
}

export async function setUpInternalInterfaces() {
    if (!import.meta.env.SSR) {
        const {
            renderBounceLayerRecommendations,
            renderPdpRecommendations,
            renderWishlistRecommendations,
            renderOrderOverviewRecommendations,
        } = await import("@otto-ec/nexus-registry/reco/cinemas");
        /*                                                                                                   */
        /*                                                                  */
        /*                                                                                   */
        /*  */
        /*                                                               */
        /*                                                                                */
        /* */
        /*                                                                    */
        /*                                                                                     */
        /*  */
        /*                                                          */
        /*                                                                           */
        /* */
    }
};

